import { Icon, MenuItem, MenuItemProps } from '@mui/material'
import Grid from '@mui/material/Grid'
import classNames from 'classnames'
import React, { PropsWithChildren, ReactElement } from 'react'

import styles from './ProfileMenuItem.module.less'

type ProfileMenuItemProps = {
  icon: string
  onClick?: () => void
} & Omit<MenuItemProps, 'onClick'>

export default function ProfileMenuItem({
  icon,
  children,
  onClick,
  ...menuItemProps
}: PropsWithChildren<ProfileMenuItemProps>): ReactElement {
  return (
    <MenuItem onClick={onClick} {...menuItemProps}>
      <Grid container direction="row" alignItems="center">
        <Grid>
          <Icon fontSize="small" className={classNames(styles.ProfileMenuItem_Icon, icon)} />
        </Grid>
        <Grid>{children}</Grid>
      </Grid>
    </MenuItem>
  )
}
